import Vue from 'vue'
import Vuex from 'vuex'
import { CHANGE_IS_LOGIN_PAGE } from './mutation-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoginPage: false,
    warning_count: 0
  },
  mutations: {
    [CHANGE_IS_LOGIN_PAGE](state, payload) {
      state.isLoginPage = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
